import { jsx as _jsx } from "react/jsx-runtime";
import isEqual from "lodash/isEqual";
import { memo, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetPublicBoardMenuOptionsCallback } from "~/components/PublicBoard/useGetPublicBoardMenuOptionsCallback";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { GalleryBoard } from "~/components/v2/components/shared/gallery/GalleryBoard";
import { usePublicLibraryCustomFields } from "~/components/v2/hooks/usePublicLibraryCustomFields";
import { useOpenPublicBoardInNewTab } from "~/hooks/useOpenPublicBoardInNewTab";
import { usePublicSelectionMenuOptions } from "~/hooks/usePublicSelectionMenuOptions";
import { useURLLibraryIdSelector } from "~/hooks/useURLLibraryIdSelector";
import { centralizedBoardLibraryIdSelector } from "~/store/centralizedBoard/selectors";
import { useGoToPublicBoard } from "~/swr-hooks/boards/useGoToPublicBoard";
import { canSeeBoardCustomFields } from "~/utils/permissions/boardPermissions";
export const PublicGalleryBoard = /*#__PURE__*/ memo((param)=>{
    let { ancestors, box, data: board } = param;
    const { permissions } = usePublicPermissions();
    const { getSelectionMenuOptions } = usePublicSelectionMenuOptions();
    const { getBoardMenuOptionsCallback } = useGetPublicBoardMenuOptionsCallback();
    const _getItemMenuOptions = getBoardMenuOptionsCallback({
        item: board
    });
    const { goToPublicBoard } = useGoToPublicBoard();
    const { openPublicBoardInNewTab } = useOpenPublicBoardInNewTab();
    const urlLibraryId = useURLLibraryIdSelector();
    const libraryId = useSelector(centralizedBoardLibraryIdSelector);
    const { data: libraryCustomField } = usePublicLibraryCustomFields({
        libraryId: libraryId || urlLibraryId
    });
    const onBoardClick = useCallback(()=>goToPublicBoard(board, "board"), [
        board,
        goToPublicBoard
    ]);
    const onBoardCmdClick = useCallback(()=>openPublicBoardInNewTab({
            board
        }), [
        board,
        openPublicBoardInNewTab
    ]);
    const libraryCustomFields = useMemo(()=>{
        var _libraryCustomField_data;
        return ((_libraryCustomField_data = libraryCustomField === null || libraryCustomField === void 0 ? void 0 : libraryCustomField.data) !== null && _libraryCustomField_data !== void 0 ? _libraryCustomField_data : []).map((customField)=>({
                ...customField,
                visible: !!customField.visible
            }));
    }, [
        libraryCustomField
    ]);
    return /*#__PURE__*/ _jsx(GalleryBoard, {
        board: board,
        box: box,
        isSelectable: true,
        libraryCustomFields: libraryCustomFields,
        onClick: onBoardClick,
        onCmdClickTitle: onBoardCmdClick,
        getItemMenuOptions: _getItemMenuOptions,
        getSelectionMenuOptions: getSelectionMenuOptions,
        ancestors: ancestors,
        canViewCustomFields: canSeeBoardCustomFields(permissions)
    }, board.id);
}, // `container` comes from `react-virtualized` and is a different object every time but may have the same values so we need to deep equal check the props
isEqual);
PublicGalleryBoard.displayName = "PublicGalleryBoard";
